module.exports = __webpack_public_path__ + "static/logo-horizontal-blanco-e505a824e79106770ff56725a50cd18b.png";